import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  effects as companyEffects,
  selectors as companySelectors,
  STATE_SEARCH,
  STATE_SUGGESTION,
} from 'lib/entities/company';
import auth from 'utils/auth';
import { ListWrapper } from '../../OnBoardingLayout/styled';
import SearchedStock from './SearchedStock';
import SuggestedStock from './SuggestedStock';

import {
  effects as discoverStockEffects,
  selectors as discoverStockSelector,
} from '../slice';

import SuggestionItemLoading from './SuggestionItemLoading';

function ListStock() {
  const [defaultWatchlistId, setDefaultWatchlistId] = useState(0);
  // handle actions & effects
  const dispatch = useDispatch();

  // Company suggestion data
  const {
    suggestions: { data: dataSuggestions, isLoading: isLoadingSuggestions },
  } = useSelector(discoverStockSelector);

  // Search company data
  const {
    search: { data: dataSearch, isLoading: isLoadingSearch },
  } = useSelector(companySelectors);

  // Did mount
  useEffect(() => {
    // fetch default recommended stock
    const { watchlist_id: watchlistId } = auth.getUserAccess();
    dispatch(discoverStockEffects.getSuggestionCompany(watchlistId));
    setDefaultWatchlistId(watchlistId);
  }, []);

  const handleToggleFollowCompany = (companyId, isFollowing) => {
    // Change flag state to update to search if user is currenty searching
    const stateToUpdate =
      dataSearch.length > 0 ? STATE_SEARCH : STATE_SUGGESTION;

    const data = {
      watchlistId: defaultWatchlistId,
      companyId,
      stateToUpdate,
    };

    if (isFollowing) {
      dispatch(companyEffects.postUnfollowCompany(data));
      return false;
    }

    dispatch(companyEffects.postFollowCompany(data));
    return true;
  };

  // TODO: Add ternary to validate if search > 0 use search, else use suggestions
  const isLoadingStocks = isLoadingSearch || isLoadingSuggestions;
  const stocks = dataSearch.length > 0 ? dataSearch : dataSuggestions;
  const SuggestionItem = dataSearch.length > 0 ? SearchedStock : SuggestedStock;

  return (
    <ListWrapper>
      {isLoadingStocks
        ? [...Array(7)].map(() => <SuggestionItemLoading />)
        : stocks.map((stock) => (
          <SuggestionItem
            key={stock.id || stock?.company_id}
            stock={stock}
            onFollow={handleToggleFollowCompany}
          />
          ))}
    </ListWrapper>
  );
}

export default ListStock;
